import { render, staticRenderFns } from "./RemoveLoansFromDealModal.vue?vue&type=template&id=1f7afae8"
import script from "./RemoveLoansFromDealModal.vue?vue&type=script&lang=ts"
export * from "./RemoveLoansFromDealModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/PortfolioWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1f7afae8')) {
      api.createRecord('1f7afae8', component.options)
    } else {
      api.reload('1f7afae8', component.options)
    }
    module.hot.accept("./RemoveLoansFromDealModal.vue?vue&type=template&id=1f7afae8", function () {
      api.rerender('1f7afae8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ClientScripts/Components/Modals/RemoveLoansFromDealModal.vue"
export default component.exports